let inProgress = false;
const listeners = new Set<() => void>();

export const setUpgradeInProgress = (value: boolean) => {
  if (inProgress === value) return;
  inProgress = value;
  listeners.forEach((l) => l());
};

export const isUpgradeInProgress = () => inProgress;

export const subscribeUpgradeInProgress = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};